import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { LOGIN_AS_MUTATION } from '../../../graphql'
import { Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner'
import { configValue, handleGraphQLErrors, setLocalStorage , extractCustomLoginData } from '../../../utils'

const LOGIN_AS = gql(LOGIN_AS_MUTATION)

export default function CrossEntityObject({ location }) {
  console.log('CrossEntityObject rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const params = new URLSearchParams(location.search)
  const objectId = params.get('in_document')

  useEffect(() => {
    async function submitSearch() {
      const email = configValue('FWContracts Read Only Email')
      const password = configValue('FWContracts Read Only Password')
      try {
        const { data, errors } = await window.apolloClient.mutate({ mutation: LOGIN_AS, variables: { email: email, password: password, tenant: 'fwcontracts' } })
        if (data.loginAs) {
          console.log('CrossEntityObject.useEffect: ', data.loginAs)
          const newLoginData = extractCustomLoginData(data.loginAs)
          setLocalStorage('fwcontracts', JSON.stringify(newLoginData))
          setResults(newLoginData)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch(e) {
        handleGraphQLErrors(e, setGraphQLErrors)
      }
    }
    submitSearch()
  })

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    window.location.href = `${window.location.origin}/fwcontracts/object/${objectId}?noPageTop=Y`
  }
}
